module.exports = __webpack_public_path__ + "static/media/groovr_sidebar_2.2cb2565e.png";